// extracted by mini-css-extract-plugin
export default {"emptyGifList":"EmptyGifLIst_emptyGifList__QpSBCN2T"};